import { db } from '../client';
import { SEED_METRICS } from './metrics';
import { generateSeedLogs, generateSeedMediaLogs } from './logs';

export interface SeedOptions {
  force?: boolean;
  days?: number;
}

async function seedMetrics(): Promise<void> {
  await db.metrics.bulkPut(SEED_METRICS);
}

async function seedLogs(days = 30): Promise<void> {
  await db.metricLogs.bulkPut(generateSeedLogs(SEED_METRICS, days));
  await db.mediaMetricLogs.bulkPut(generateSeedMediaLogs(SEED_METRICS, days));
}

export async function seedDatabaseIfEmpty(
  opts: SeedOptions = {}
): Promise<void> {
  const { force = false, days = 30 } = opts;

  const metricCount = await db.metrics.count();
  if (!force && metricCount > 0) {
    return;
  }

  await seedMetrics();
  await seedLogs(days);
}
